import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { requestGetContacts } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { de, el } from "date-fns/locale";
import { set } from "date-fns";

function ContactSearch(props) {
    const [contactAll, setContactsAll] = useState(JSON.parse(localStorage.getItem("contacts")));
    const [filterItem, setFilterItem] = useState([]);
    const [id, setid] = useState(0);
    const [user, setuser] = useState(null);
    const [showTable, setShowTable] = useState(true);
    const [contacts, setContacts] = useState(null);

    const handleSearchChange = (value) => {
        setShowTable(true);
        const filtered = contactAll.filter(contact =>
            (contact.name || '').toLowerCase().includes(value.toLowerCase()) ||
            (contact.email || '').toLowerCase().includes(value.toLowerCase()) ||
            (contact.mobile || '').toLowerCase().includes(value.toLowerCase())
        );

        setFilterItem(filtered);
        if (filtered.length > 0) {
            ItemDiv(filtered);
        }
    }

    function handleAddToCart(custId) {
        setid(custId);
        setShowTable(false);
        const selected = contactAll.find(contact => contact.custId === custId);
        setuser(selected);
        props.onContactSelect && props.onContactSelect(selected);
    }

    function ItemDiv({ filterItem }) {
        if (!Array.isArray(filterItem) || filterItem.length === 0) {
            return '';
        }
        return (
            <div className="card">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th hidden></th>
                            <th scope="col">Name</th>
                            <th scope="col">PhoneNo</th>
                            <th scope="col">Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterItem.map((item, index) => (
                            <tr key={index} onClick={() => handleAddToCart(item.custId)} style={{ cursor: "pointer" }}>
                                <th scope="row">{index + 1}</th>
                                <td hidden>{item.id}</td>
                                <td>{item.name || "—"}</td>
                                <td>{item.mobile || "—"}</td>
                                <td>{item.email ?? "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                setShowTable(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    const handleInputChange = (id, value) => {
        const numericValue = parseInt(value, 10);
        setContacts(prevItems =>
            prevItems.map(item =>
                item.id === id
                    ? { ...item, qty: isNaN(numericValue) ? 0 : numericValue, amount: item.price * numericValue }
                    : item
            )
        );
    };

    return (
        <div className="contact-view">
            <div className="row" style={{ position: "relative" }}>
                {/* <div className="col-md-6"><h6>Cart product of </h6> <h4>{props.cname}</h4></div> */}
                <div className="col-md-6">
                    <div className="row">
                        <div style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            zIndex: 99,
                            background: "white" // optional, but useful if you want to visually separate
                        }}>
                            <input type="text" placeholder="search contact..." className="form-control" onChange={e => handleSearchChange(e.target.value)}></input>
                            {showTable && <ItemDiv filterItem={filterItem} />}
                            <input type="number" id="custId" name="custId" value={id} hidden onChange={e => setid(e.target.value)}></input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestGetContacts }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactSearch);